import React from "react"
import styled from "styled-components"
import { Flex, StyledLink } from "../../styles/base-styles"
import { WpPost } from "../../types/wordpress-types"
import { getCategorySettings, TEXTS } from "../../utils/constants"

interface Props {
  title: string
}

export const PostsSectionHeader: React.FC<Props> = ({ title }) => {
  return (
    <PostsSectionHeaderDiv>
      <H2Div>{title}</H2Div>
      <H2Border />
    </PostsSectionHeaderDiv>
  )
}

const PostsSectionHeaderDiv = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-bottom: 32px;
`

const H2Div = styled.h2`
  color: var(--Dark_Gray, #242424);
  font-feature-settings: "clig" off, "liga" off;
  /* H2 */
  font-family: san-serif;
  font-size: 34px;
  font-style: normal;
  font-weight: bold;
  line-height: 160%; /* 54.4px */
  letter-spacing: 1.28px;
  margin-right: 8px;
  word-break: break-word;
  /* SP style */
  @media screen and (max-width: 767px) {
    flex: 1 1 auto;
    color: var(--Dark_Gray, #242424);
    font-feature-settings: "clig" off, "liga" off;
    /* SP_H2 */
    font-family: san-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 160%; /* 32px */
    letter-spacing: 1.28px;
  }
`
const H2Border = styled.div`
  flex: 1 1 auto;
  min-width: 62px;
  height: 2px;
  background: var(--Dark_Gray, #242424);
  /* SP style */
  @media screen and (max-width: 767px) {
    min-width: 62px;
    flex: 0 0 62px;
  }
`
